<template>
  <div>
    <div v-if="show">
        Ваш пароль для прохождения анкеты: {{pass}}
    </div>
    <div v-if="!show">
      <table class="table">
        <tr>
          <th v-for="str in struct" :key="str.id">{{str.title}}</th>
        </tr>     
        <tr>
          <td v-for="str in struct" :key="str.id" :class="str.style">{{str.text}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

var struct = [
  {
    id: 1,
    title: "Заявка",
    text: "Получена",
    style: "alert alert-success"
  },
  {
    id: 2,
    title: "Заявка",
    text: "Получена",
    style: "alert alert-success"
  },
  {
    id: 3,
    title: "Заявка",
    text: "Получена",
    style: "alert alert-success"
  },
  {
    id: 4,
    title: "Заявка",
    text: "Получена",
    style: "alert alert-success"
  }
];

import axios from 'axios';

export default {
  created: function(){
    axios({
      url: 'http://egechita.ru/inc/zaglushka.php?getpass=1',
      withCredentials: true

      }).then((response) => {
      if(response.data.ok == 1){
        this.pass = response.data.pass;
      }
    });    
  },
  data: function() {
    return {
      struct: struct,
      show: true,
      pass: ""
    };
  }
};
</script>
